<h2>Tem certeza?</h2>
<mat-dialog-content class="mat-typography">
  <p>
    Se deletado, esse anexo será perdido.
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">Cancelar</button>
  <button mat-raised-button color="warn" [mat-dialog-close]="true">Sim</button>
</mat-dialog-actions>
